import React from "react";

const TableLoading = ({ rows = 3, columns = 2 }) => {
    return (
        <>
            <table className="w-full border-collapse">
                <thead>
                    <tr className="bg-[#F9FAFB] dark:bg-[#424E59] border-y border-[#E5E7EB] dark:border-[#424E59] text-[15px] leading-6 text-[#6B7280] dark:text-white">
                        <th className="px-6 py-[10px] text-left ">Status</th>
                        <th className="px-4 py-2 text-left ">Count</th>
                    </tr>
                </thead>
                <tbody className="w-full">
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className="bg-white dark:bg-[#0D1822] border-y border-gray-200 dark:border-[#424E59] animate-pulse last:border-non"
                        >
                            {Array.from({
                                length: columns,
                            }).map((_, colIndex) => (
                                <td key={colIndex} className="p-6">
                                    <div className="h-4 bg-gray-300 dark:bg-[#424E59] rounded w-full"></div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default TableLoading;
